"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReservesAbi = void 0;
exports.getReservesAbi = [
    {
        inputs: [],
        name: 'getReserves',
        outputs: [
            {
                internalType: 'uint112',
                name: '_reserve0',
                type: 'uint112',
            },
            {
                internalType: 'uint112',
                name: '_reserve1',
                type: 'uint112',
            },
            {
                internalType: 'uint32',
                name: '_blockTimestampLast',
                type: 'uint32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];
//# sourceMappingURL=getReservesAbi.js.map